import { reactive } from "vue"

export const systemBoot = reactive({

    phase: "idle",
    ready: false,
    message: "",

    setPhase(phase, message = "") {

        this.phase = phase
        this.message = message

    }

})